S.header =
    {
        config: {
            // height navbar
            offset: 50 + 95,
        },

        elements: {
            $menuIcon: null,
            $searchIconMobile: null,
            $searchIconDesktop: null,
            $navigation: null,
            $searchLayer: null,
            $font: null,
            $contrast: null,
        },

        init()
        {
            this.menuMobile();
            this.searchLayerMobile();
            this.searchLayerDesktop();
            this.focusLastLinkInMenu();
            this.menuHidden();
            this.keyTab();
            this.listen();
            this.increaseFont();
            this.styleSwitcher();

            // sticky header
            // https://wicky.nillia.ms/headroom.js/
            $('#header').headroom();
        },

        keyTab()
        {
            this.elements.$menuIcon.on('keydown', (e) =>
            {
                if (e.keyCode === 13 || e.which === 32)
                {
                    setTimeout(function ()
                    {
                        $('#button_menu').focus();
                        $('body').addClass('is-keyboard-focus');
                    }, 25);
                }
                // escape
                else if (e.keyCode === 27)
                {
                    this.closeMobileNav();
                }
            });
        },

        menuHidden()
        {
            if (!S.mq('l', false).matches)
            {
                this.elements.$navigation.css('visibility', 'hidden');
            }
        },

        menuVisible()
        {
            if (S.mq('l', false).matches)
            {
                this.elements.$navigation.css('visibility', 'visible');
            }
        },

        ariaExpandedRemove($element)
        {
            $element.removeAttr('aria-expanded');
        },

        ariaExpandedAdd($element)
        {
            $element.attr('aria-expanded', true);
        },

        // check last link focus in menu
        focusLastLinkInMenu()
        {
            // $('main a, footer a, main button, footer button, .m-button').on('focus', () =>
            $('main *, footer *').on('focus', () =>
            {
                // menu close or jump to close button
                if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    // this.closeMobileNav();
                    $('#button_menu').focus();
                }
                // open searchlayer
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    // mobile
                    if ($('#button_menu').is(':visible'))
                    {
                        this.elements.$searchIconMobile.find('button').focus();
                    }
                    // desktop
                    else
                    {
                        S.header.searchLayerClose();
                    }
                }
            });
        },

        /* set top from mobilenav by iconclick */
        startPositionMobileNav()
        {
            const navHeight = this.elements.$navigation[0].scrollHeight - this.config.offset;

            // mobile and tablet only
            if (!S.mq('l', false).matches)
            {
                // console.log(navHeight);
                this.elements.$navigation.css('top', -navHeight);

                setTimeout(() =>
                {
                    this.elements.$navigation.addClass('is-transition');
                }, 20);
            }
        },

        openMobileNav()
        {
            this.$module.addClass('is-mobile-nav-open');
            this.startPositionMobileNav();
            this.ariaExpandedAdd($('#button_menu'));
            this.elements.$navigation.css('visibility', 'visible');
            $('#button_menu').focus();

            if (S.mq('tablet', false).matches)
            {
                // different offset
                // this.config.offset += 10;
            }

            setTimeout(() =>
            {
                this.elements.$navigation.css('top', this.config.offset + 'px');
            }, 40);

            if (this.elements.$searchLayer.hasClass('is-active'))
            {
                this.searchLayerClose();
            }

            this.elements.$searchIconMobile.removeClass('is-active');
            S.bglayer.open();
        },

        checkNavPosition()
        {
            // hidden if fully on -top
            const navHeight = this.elements.$navigation[0].scrollHeight - this.config.offset;

            setTimeout(() =>
            {
                const pos = this.elements.$navigation.position();

                if (pos.top > -navHeight + 20)
                {
                    // console.log(pos.top);
                    this.checkNavPosition();
                }
                else
                {
                    this.elements.$navigation.css('visibility', 'hidden');
                }
            }, 100);
        },

        closeMobileNav()
        {
            this.$module.removeClass('is-mobile-nav-open');
            this.startPositionMobileNav();
            this.ariaExpandedRemove($('#button_menu'));
            this.checkNavPosition();
            S.bglayer.close();
        },

        // returnFocus()
        // {
        //     this.elements.$menuIcon.on('keydown', (e) =>
        //     {
        //         if (e.which === 13)
        //         {
        //             $('body').addClass('is-keyboard-focus');
        //         }
        //     });
        // },

        menuMobile()
        {
            this.elements.$menuIcon.on('click', () =>
            {
                if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    this.closeMobileNav();
                }
                else
                {
                    this.openMobileNav();
                }
            });
        },

        setDesktopNav()
        {
            this.elements.$navigation.css('top', 0);
        },

        searchLayerClose()
        {
            this.$module.removeClass('is-searchlayer-open');
            this.elements.$searchLayer.stop().fadeOut();
            this.elements.$searchLayer.removeClass('is-active');
            this.elements.$searchIconMobile.removeClass('is-active');
            this.ariaExpandedRemove(this.elements.$searchIconMobile.find('button'));
            this.ariaExpandedRemove(this.elements.$searchIconDesktop.find('button'));
            this.elements.$searchIconMobile.removeClass('is-open');
            S.bglayer.close();
        },

        searchLayerOpen()
        {
            this.$module.addClass('is-searchlayer-open');
            this.elements.$searchLayer.stop().fadeIn();
            this.elements.$searchLayer.addClass('is-active');
            $('#search input').focus();
            this.elements.$searchIconMobile.addClass('is-open');
            S.bglayer.open();
        },

        searchLayerMobile()
        {
            this.elements.$searchIconMobile.on('click', () =>
            {
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    // this.elements.$searchIconMobile.removeClass('is-active');
                    this.searchLayerClose();
                    S.bglayer.close();
                }
                else
                {
                    this.searchLayerOpen();
                    this.ariaExpandedAdd(this.elements.$searchIconMobile.find('button'));
                    // this.elements.$searchIconMobile.addClass('is-active');

                    if (this.$module.hasClass('is-mobile-nav-open'))
                    {
                        this.closeMobileNav();
                    }

                    S.bglayer.open();
                }
            });
        },

        searchLayerDesktop()
        {
            this.elements.$searchIconDesktop.on('click', () =>
            {
                if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    this.searchLayerClose();
                }
                else
                {
                    this.searchLayerOpen();
                    this.ariaExpandedAdd(this.elements.$searchIconDesktop.find('button'));
                    this.elements.$searchIconMobile.addClass('is-active');
                }
            });
        },

        listen()
        {
            // Wenn IE11 Unterstützung benötigt wird, bleibt das auch so. Wenn nur moderne Browser unterstützt werden sollen, dann kann man addEventListener() verwenden.
            S.mq('l').addListener((mq) =>
            {
                if (mq.matches)
                {
                    if (this.$module.hasClass('is-mobile-nav-open'))
                    {
                        this.setDesktopNav();
                        S.bglayer.close();
                    }
                    else
                    {
                        this.setDesktopNav();
                    }

                    this.menuVisible();
                }
                // searchlayer desktop open
                else if (this.elements.$searchLayer.hasClass('is-active'))
                {
                    this.closeMobileNav();
                    S.bglayer.open();
                    this.menuHidden();
                }
                // mobilenav opend
                else if (this.$module.hasClass('is-mobile-nav-open'))
                {
                    // S.slide.openAllSlides();
                    this.elements.$navigation.css('top', this.config.offset + 'px');
                    S.bglayer.open();
                    this.menuVisible();
                }
                // mobilenav closed
                else
                {
                    // S.slide.openAllSlides();
                    this.startPositionMobileNav();
                    this.menuHidden();
                }
            });
        },

        increaseFont()
        {
            this.elements.$font.on('click', () =>
            {
                $('html').toggleClass('is-increased-font').toggleClass('is-active');
                this.elements.$font.toggleClass('is-active');

                if ($('html').hasClass('is-increased-font'))
                {
                    localStorage.setItem('increaseFont', 1);
                }
                else
                {
                    localStorage.removeItem('increaseFont');
                }
            });

            if (localStorage.getItem('increaseFont'))
            {
                $('html').addClass('is-increased-font');
            }
        },

        /* store contrast data in localStorage by iconclick */
        styleSwitcher()
        {
            if (localStorage.getItem('contrast') === 'on')
            {
                $('body').addClass('is-contrast');
            }
            else
            {
                $('body').removeClass('is-contrast');
            }

            this.elements.$contrast.on('click', () =>
            {
                if ($('body').hasClass('is-contrast'))
                {
                    $('body').removeClass('is-contrast');
                    localStorage.setItem('contrast', 'off');
                }
                else
                {
                    $('body').addClass('is-contrast');
                    localStorage.setItem('contrast', 'on');
                }
            });
        },
    };
